module.exports = __webpack_public_path__ + "static/media/andarilho.d44dde6e.png";